import type { EntityKey, IOdataEntityResource } from './types';

export interface EntityCacheIdentity {
  idOrPath: EntityKey;
  resourcePath: string;
}

const ENTITY_CACHE_KEY_PREFIX = 'entity:';

export function createEntityCacheKey(resource: IOdataEntityResource): string {
  const idOrPath = resource.navigation.key ?? resource.path;
  return `${ENTITY_CACHE_KEY_PREFIX}${JSON.stringify([idOrPath, resource.path])}`;
}

export function parseEntityCacheKey(cacheKey: EntityKey): EntityCacheIdentity {
  if (typeof cacheKey === 'string' && cacheKey.startsWith(ENTITY_CACHE_KEY_PREFIX)) {
    const [idOrPath, resourcePath] =
      JSON.parse(cacheKey.slice(ENTITY_CACHE_KEY_PREFIX.length)) as [EntityKey, string];
    return {
      idOrPath,
      resourcePath,
    };
  }

  return {
    idOrPath: cacheKey,
    resourcePath: String(cacheKey),
  };
}

export function entityCacheKeyMatchesId(cacheKey: EntityKey, id: EntityKey): boolean {
  return String(parseEntityCacheKey(cacheKey).idOrPath) === String(id);
}
